import React from "react";
import {NavBarNoAuth} from "./NavBar";
import {Link} from "react-router-dom";

class Overview extends React.Component {
    render() {
        return (
            <div>
                <NavBarNoAuth/>
                <h1>
                    What is SimGPS?
                </h1>
                <div>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore
                    et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris.
                </div>
                <h1>
                    Where do I get it?
                </h1>
                <div>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore
                    et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris.
                </div>
                <h1>
                    How do I become SimGPS partner?
                </h1>
                <div>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore
                    et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
                    aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse
                    cillum dolore eu fugiat nulla pariatur.
                    <Link to="/partner">Partner Portal</Link>
                </div>
                <h1>
                    Manufacturer Portal
                </h1>
                <div>
                    <Link to="/manufacturer">Manufacturer Portal</Link>
                </div>
            </div>

        );
    }
}

export default Overview;
